export var PartnersAgencyStatus;
(function (PartnersAgencyStatus) {
    PartnersAgencyStatus["NORMAL"] = "NORMAL";
    PartnersAgencyStatus["SUSPENDED"] = "SUSPENDED";
    PartnersAgencyStatus["ERROR"] = "ERROR";
    PartnersAgencyStatus["WITHDRAWN"] = "WITHDRAWN";
})(PartnersAgencyStatus || (PartnersAgencyStatus = {}));
